import React from 'react';

const FeedbackRow = ({ employeeName, entry }) => {
  const { rating, comment, feedbackCreatedBy, appointmentID, createdAt } = entry;

  return (
    <tr>
      <td>{employeeName}</td>
      <td>{rating}</td>
      <td>{comment}</td>
      <td>{feedbackCreatedBy?.name}</td>
      <td>{appointmentID?.date ? new Date(appointmentID.date).toLocaleDateString() : ''}</td>
      <td>{appointmentID?.time}</td>
      <td>{createdAt ? new Date(createdAt).toLocaleString() : ''}</td>
    </tr>
  );
};

export default FeedbackRow;
